<script setup>
import Sidebar from "@/components/navigation/Sidebar.vue";
import PrivateHeader from '@/components/navigation/PrivateHeader.vue';
</script>

<template>

    <div class="flex flex-col h-screen bg-base-200">

        <div class="bg-base-100 border-b shadow flex flex-col">
    
            <div class="flex flex-col px-2 sm:px-3 lg:px-4">
                <PrivateHeader />
            </div>

        </div>
    
        <div class="flex flex-1 overflow-y-hidden">

            <Sidebar />

            <main class="flex-1 min-w-0 overflow-y-auto m-4 gap-4">

                <slot></slot>

            </main>

        </div>
    
    </div>

</template>
